import React, { useState } from "react";
import "./mobfilter.css";

import { BiFilterAlt } from "react-icons/bi";
// import $ from 'jquery';
// import 'jquery-ui-dist/jquery-ui';
import Form from "react-bootstrap/Form";
// import { IconContext } from 'react-icons';
import * as AiIcons from "react-icons/ai";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Sort from "../../components/Mobfilter/MobSort";
import { AiFillStar } from "react-icons/ai";
import FilterRating from "../filterRating/FilterRating";
import SearchContext from "../../context/SearchContext";
import { useContext } from "react";
import { baseUrl } from "../../context/BaseUrl";
import { useEffect } from "react";


const MobFilter = ({ category_id }) => {
  const { search, setSearch } = useContext(SearchContext);
  const [result, setResult] = useState(false);
  const [subject, setSubject] = useState([]);
  const [filter, setFilter] = useState(false);
  const [data, setData] = useState(false);
  const [citydata, setCitydata] = useState(false);
  const [show, setShow] = useState(false);
  const [price, setPrice] = useState("");
  const handlerange = (e) => {
    setPrice(e.target.value);
    setSearch({ ...search,  budget_max: e.target.value })
  };
  const [rate, setRate] = useState(0);
  const loadExam = async () => {
    const dataExam = await fetch(
      `${baseUrl}/user/category/getcategory_details/${category_id}`
    );
    const subject = await dataExam.json();

    setResult(subject);
  };
  useEffect(() => {
    loadExam();
  }, []);

  const handlestate = (e) => {
    const value = e.target.value;
    const state_obj = data[0].states.filter((val, i)=> val.state_id == value );
    const CityApi = async () => {

      const response = await fetch(`https://cdn-api.co-vin.in/api/v2/admin/location/districts/${state_obj[0].state_id}`, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      if (result.error) {
        console.warn("got an error in response", result.error);
        return;
      }
        setCitydata([result]);
    };
    CityApi();
  };

  const ApiPost = async () => {

    const response = await fetch(`https://cdn-api.co-vin.in/api/v2/admin/location/states`, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.error) {
      console.warn("got an error in response", result.error);
      return;
    }
      setData([result]);
  };
  
  useEffect(() => {
  ApiPost();
}, []);
useEffect(() => {
  setSearch({...search, 
    rating: rate,
    budget_max: price,
    sort: "namea",
 })
}, [citydata, rate]);
 
const handleCourse = (e) => {
  const subName = e.target.id;
  const sub = e.target.checked;

  if (sub){
    subject.push(subName)
  }
  if(!sub){
    const remove = subject.findIndex((item) => item == subName);
    subject.splice(remove, 1)
  }
  setSearch({ ...search, subject: subject })
}

  return (
    <>
      <div className="filter-mob">
        <div className="table-filter">
          <Sort search={search} setSearch={setSearch} />
          <div className="filter-popup">
            <div className="filter" onClick={() => setFilter(!filter)}>
              <BiFilterAlt className="filter" /> Filter
            </div>
            {filter ? (
              <div className="popupshow">
                <h3>
                  Filters{" "}
                  <AiIcons.AiOutlineClose onClick={() => setFilter(!filter)} />
                </h3>

                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={3} xs={6}>
                      <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                          <Nav.Link eventKey="first">Courses</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">Location</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="third">Rating</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="fourth">Mode of Course</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="fifth">Budget</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9} xs={6}>
                      <Tab.Content>
                        <Tab.Pane eventKey="first">
                          <Form>
                          {result.subjects.map((el, loop) => (
                        <div key={loop}>
                          <Form.Check
                            className="mb-3"
                            label={`${el}`}
                            name={`subject`}
                            type={"checkbox"}
                            id={`${el}`}
                            onClick={handleCourse}
                          />
                        </div>
                      ))}
                          </Form>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                        <div className="mb-1 row">
                    <div className="col-12">
                        <label htmlFor="State" className="col-form-label">State</label>
                        <Form.Select className='' onChange={handlestate} >
                        <option value=''>Select Institute......</option>
                        {data ? data[0].states.map((item, index)=> <option key={index} value={item.state_id}> {item.state_name} </option>) : <option> 1 </option> }
                      </Form.Select>
                      </div>
                      <div className="col-12">
                        <label htmlFor="City" className="col-form-label">City</label>
                        <Form.Select className='' onChange={(e) => setSearch({ ...search, location: [e.target.value] })} name="city">
                        <option value=''>Select Institute......</option>
                        {citydata ? citydata[0].districts.map((item, index)=> <option key={index} value={item.district_name}> {item.district_name} </option>) : <option value=''>Please select state first</option> }
                      </Form.Select>
                      </div>
                    </div>
                          {/* <Form>
                          {["checkbox"].map((type) => (
                        <div key={`reverse-${type}`}>
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Delhi"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-1`}
                          />
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Mumbai"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-2`}
                          />
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Kolkata"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-3`}
                          />
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Banglore"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-4`}
                          />
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Pune"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-4`}
                          />
                        </div>
                      ))}
                          </Form> */}
                        </Tab.Pane>
                        <Tab.Pane eventKey="third">
                          <div className="rating">
                            <FilterRating handle={{ rate, setRate }}/>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="fourth">
                          <Form>
                          <Form.Select
                      className="form-control"
                      onChange={(e) =>
                        setSearch({ ...search, available: e.target.value })
                      }
                    >
                      <option value={"online"}>Online</option>
                      <option value={"offline"}>Offline</option>
                      <option value={"both"}>Both</option>
                    </Form.Select>
                          </Form>
                        </Tab.Pane>
                        <Tab.Pane eventKey="fifth">
                          <div className="range d-flex align-items-center flex-column gap-1 px-1">
                            <div className="d-flex justify-content-between w-100 mb-0">
                              ₹50000<output>{price}</output>
                            </div>
                            <input
                        type="range"
                        style={{ width: "150px" }}
                        min="50000"
                        max="200000"
                        step="5000"
                        value={price}
                        onInput={handlerange}
                      />
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
                <div className="filterBtns">
                  <button className="cancel" onClick={() => setFilter(!filter)}>Cancel</button>
                  <button className="apply" onClick={() => setFilter(!filter)}>Apply</button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobFilter;
